import { useRef, useState, useEffect } from "react";
import styles from "../../mainPage.module.css";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import "react-multi-date-picker/styles/layouts/prime.css";
import makeAnimated from "react-select/animated";
import CreatableSelect from "react-select/creatable";
import "../../transform.css";
import toast, { Toaster } from "react-hot-toast";

import { addCommas, removeCommas } from "@persian-tools/persian-tools";

const TodoForm = ({ allUserTag, addTodoHandler }) => {
  const [valueDateStart, setValueDateStart] = useState();
  const [valueDatePayan, setValueDatePayan] = useState();
  const [price, setPrice] = useState(0);
  const [valUserTag, setValUserTag] = useState("");
  const inputRef = useRef(null);

  const changeHandlerJazebe = (option) => {
    setValUserTag(option);
  };
  useEffect(() => {
    inputRef.current.focus();
  }, []);

  const changeHandlerPrice = (e) => {
    setPrice(removeCommas(e.target.value));
  };

  const animatedComponents = makeAnimated();
  function AnimatedMulti() {
    return (
      <CreatableSelect
        closeMenuOnSelect={true}
        components={animatedComponents}
        isMulti={false}
        options={allUserTag}
        value={valUserTag}
        onChange={changeHandlerJazebe}
        className={styles.filterSelect}
      />
    );
  }

  const submitHandler = (e) => {
    e.preventDefault();

    addTodoHandler(valueDateStart, valueDatePayan, price, valUserTag);
    setValueDateStart("");
    setValueDatePayan("");
    setPrice("");
    setValUserTag("");
  };

  return (
    <div className=" date-picker1">
      <form onSubmit={submitHandler} className={styles.formTodos}>
        <button type="submit" className={styles.inputBtn}>
          +
        </button>
        <div className={styles.formInputx}>{AnimatedMulti()}</div>

        <input
          type="text"
          onChange={changeHandlerPrice}
          value={addCommas(price)}
          ref={inputRef}
          className={styles.inputBoxRezerv}
          placeholder="قیمت "
        />

        <DatePicker
          className={`rmdp-prime  dateBox`}
          showOtherDays
          calendar={persian}
          locale={persian_fa}
          calendarPosition="bottom-right"
          value={valueDatePayan * 1000}
          placeholder=" پایان رزرو"
          onChange={(value) => {
            setValueDatePayan(value.unix);
          }}
        />

        <DatePicker
          className={`rmdp-prime  dateBox`}
          showOtherDays
          calendar={persian}
          locale={persian_fa}
          calendarPosition="bottom-right"
          value={valueDateStart * 1000}
          placeholder=" شروع رزرو"
          onChange={(value) => {
            setValueDateStart(value.unix);
          }}
        />
      </form>
    </div>
  );
};

export default TodoForm;
